import { Box, Button, Typography } from "@mui/material"
import { firstCap } from "../../../../helper/utils"
import { colors } from "../../../../styles/commonStyles"

type Props = {
  status: any
  fontSize: number
  padding: string
}

const StatusButton = (props: Props) => {
  const { status, fontSize, padding } = props

  const textColor = "#FFFFFF"
  // status == "active"
  //   ? "#42B2A0"
  //   : status == "invited"
  //     ? "#A76ED5"
  //     : status == "inactive"
  //       ? "#F6A623"
  //       : "#4e4e4e"

  //   const backgroundColor =
  //     status == "Active"
  //       ? "#E6F8E9"
  //       : status == "invited"
  //       ? "#9F73CE1A"
  //       : status == "Inactive"
  //       ? "#E480811A"
  //       : "#4e4e4e"

  const backgroundColor =
    status == "active"
      ? colors.primaryGreen
      : status == "invited"
        ? colors.primaryPurple
        : status == "inactive"
          ? colors.primaryRed
          : "#4e4e4e"

  const borderColor = "#FFFFFF"
  // status == "active"
  //   ? "#42B2A0"
  //   : status == "invited"
  //     ? "#9F73CF"
  //     : status == "inactive"
  //       ? "#E48081"
  //       : "#4e4e4e"

  const customPadding =
    padding == "small" ? "2px 6px" : padding == "medium" ? "5px 12px" : "0px"

  return (
    <Box
      sx={{
        width: "fit-content",
        padding: customPadding,
        margin: "0",
        backgroundColor: backgroundColor,
        border: `1px solid ${borderColor}`,
        borderRadius: "4px",
      }}
    >
      <Typography
        sx={{ textTransform: "capitalize" }}
        fontSize={fontSize}
        color={textColor}
        fontWeight={500}
      >
        {status}
      </Typography>
    </Box>
  )
}

export default StatusButton
